import React from 'react'
import EmpModal from '../../../../components/common/form/modal/EmpModal'

const EmpModalContainer = ({ roleTyp, title, multi, open, handleClose, selectedEmployee }) => {
    return (
        <div>
            <EmpModal
                roleTyp={roleTyp}
                title={title}
                multi={multi}
                open={open}
                handleClose={handleClose}
                selectedEmployee={selectedEmployee}
            />
        </div>
    )
}

export default EmpModalContainer